module.exports = __webpack_public_path__ + "media/images/icon_tab1_on-b217a4cd1c40d40ecef788152732acef.png";